import React, { useState, useCallback, useMemo } from "react";
import Label from "lib/Label";
import ErrorMessage from "lib/ErrorMessage";
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
const MultiSelectDropdown = (props) => {
  const {
    name,
    error,
    options,
    onChange,
    isEditable,
    validators,
    question,
    title,
    id,
    questionnaireId,
    content,
    riskProfile,
  } = props;
  const questionData = useSelector((state) => state.formData?.questionData);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const errorClass = useMemo(
    () => (error?.length ? "error_outline" : ""),
    [error]
  );
  const IndirectEval = (item) => {
    return eval(item);
  };
  const answers = useMemo(
    () =>
      questionData
        .filter((item) => item.question_id === id)
        .map((item) => item.answer)
        .join(", "),
    [questionData, id]
  );



const handleCheckboxChange = useCallback(
  (option) => {
    setSelectedOptions((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.optionId === option.id
      );
      const optionData = {
        label: option.label,
        optionId: option.id,
        score: Number(option.score) || 0,
      };
      let newSelectedOptions;

      if (isSelected) {
        newSelectedOptions = prevSelected.filter(
          (selected) => selected.optionId !== option.id
        );
      } else {
        if (prevSelected.length >= validators?.max_length) {
          return prevSelected;
        }
        newSelectedOptions = [...prevSelected, optionData];
      }

      const totalScore = newSelectedOptions.reduce((sum, selected) => {
        return sum + Math.max(selected.score, 0);
      }, 0);

      if (onChange) {
        onChange(
          id,
          option.label,
          question,
          !isSelected,
          totalScore,
          questionnaireId,
          name,
          content
        );
      }
      return newSelectedOptions;
    });
  },
  [id, question, questionnaireId, name, content, onChange]  
);





  const isChecked = useCallback(
    (option) => {
      return questionData.some(
        (data) => data.question_id === id && data.answer.includes(option.label)
      );
    },
    [questionData, id]
  );
  const sortedOptions = useMemo(() => {
    if (!options) return [];
    const selectedOptionLabels = new Set(
      questionData
        .filter((data) => data.question_id === id)
        .flatMap((data) => data.answer)
    );
    const selected = options.filter((option) =>
      selectedOptionLabels.has(option.label)
    );
    const unselected = options.filter(
      (option) => !selectedOptionLabels.has(option.label)
    );
    return [...selected, ...unselected];
  }, [options, questionData, id]);
  return (
    <div
      className={`${
        riskProfile ? `bg-body-tertiary` : ` ${errorClass}`
      } border border-secondary rounded p-3 py-4 mt-4`}
    >
      <p className="mb-0 fs-12px text-secondary">{title}</p>
      <Label
        className="question_label text-secondary"
        label={question}
        validators={validators}
      />
      {content ? (
        <div
          className="table table-responsive"
          dangerouslySetInnerHTML={{ __html: IndirectEval(content) }}
        />
      ) : (
        content
      )}
      <Dropdown
        className={`${errorClass} border border-theme rounded `}
        autoClose="outside"
        drop="down-centered"
      >
        <Dropdown.Toggle
          disabled={riskProfile}
          id="dropdown-autoclose-outside"
          className={`bg-white border-0 text-black text-start w-100 d-flex align-items-center justify-content-between`}
        >
          <p
            className={`mb-0 fs-15px ${
              answers.length > 4 ? "text-truncate w-90" : "w-100"
            }`}
          >
            {answers.length === 0
              ? "Select an option"
              : answers.split(",").map((answer, index, array) => (
                  <React.Fragment key={index}>
                    {answer.trim()}
                    {index < array.length - 1 && ", "}
                  </React.Fragment>
                ))}
          </p>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 7.605 4.302"
                class=""
              >
                <path
                  id="Path_8068"
                  data-name="Path 8068"
                  d="M0,0,3.1,3.1,0,6.191"
                  transform="translate(6.898 0.707) rotate(90)"
                  fill="none"
                  stroke="#343a40"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  opacity="0.995"
                ></path>
              </svg>
            </span>
         
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={`max-w-0 w-100 ${
            sortedOptions.length > 10
              ? "h-350px theme-scrollbar-hover overflow-y-scroll"
              : ""
          }`}
        >
          {sortedOptions.map((option) => {
            const { id, label } = option;
            return (
               <label key={id} htmlFor={id}  className="bg-active-grey d-flex align-items-center py-1 px-3">
               <input
                 type="checkbox"
                 className="h-15px w-15px accent-theme me-2"
                 id={id}
                 name={name}
                 disabled={!isEditable}
                 onClick={() => handleCheckboxChange(option)}
                 checked={isChecked(option)}
               />
                 <span className="mt-1">
                 {label}
                 </span>
               </label>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
      {error?.length > 0 && <ErrorMessage error={error} />}
      {validators?.min_lenght <answers.length && <ErrorMessage
            error={`You can't enter more than ${validators?.min_length} characters`}
          /> }
    </div>
  );
};
export default MultiSelectDropdown;